import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ChangeSet} from "../order-history.model";
import {OrderStatusEnum, Product} from "../../../../store/state/order.state";

@Component({
    selector: 'order-changes',
    templateUrl: './order-changes.template.html',
    styleUrls: ['./order-changes.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderChangesComponent {

	@Input() changeSet: ChangeSet;
	@Input() latestOrderChanges: boolean;
	@Input() showDailyRate: boolean;
	@Input() includeOffsiteDays: boolean;
	@Input() isLead: boolean;
	@Input() billingInfoVisible: boolean;

	collapsed: boolean = true;

	private readonly DECLINE_STATUSES = [OrderStatusEnum.DECLINED_BY_CLIENT, OrderStatusEnum.DECLINED_BY_APPLICATION_REVIEWER, OrderStatusEnum.DECLINED_BY_TECHNICAL_REVIEWER,
		OrderStatusEnum.TRANSFER_DECISION_NEGATIVE];

	toggleCollapse() {
		this.collapsed = !this.collapsed;
	}

	get offerHistoryStatus(): string {
		if (!this.latestOrderChanges) {
			return 'inactive';
		} else if (this.DECLINE_STATUSES.includes(this.changeSet.order.status)) {
			return 'declined';
		} else {
			return 'active';
		}
	}

	totalPrice(): number {
		return this.changeSet.order.products.map(product => product.pricing.totalPrice).reduce((p1, p2) => p1 + p2);
	}

	totalAuditTime(): number {
		return this.changeSet.order.products.map(product => product.pricing.totalAuditTime).reduce((t1, t2) => t1 + t2);
	}

	orderNumber(): string {
		return this.changeSet.order.orderNumber;
	}

	orderUuid(): string {
		return this.changeSet.order.orderUuid;
	}

	orderCorrelationId(): string {
		return this.changeSet.order.orderCorrelationId;
	}

	products(): Product[] {
		return this.changeSet.order.products;
	}
}
